<template>
	<a class="font-medium underline"><slot /></a>
</template>
